/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import React, { useContext } from "react";
import { ContentZoneContext } from "cms/components/context";
import { EmptyContentMessage } from "cms/components/layout/empty/empty-content-message";
import { isArrayEmpty, isArrayNotEmpty } from "utils/empty-exists";
import { Webpage } from "./webpage";

const FeatureWebpageComponentDisplay = () => {
    
    const { component } = useContext(ContentZoneContext);
    const title = component?.title ?? "";
    const webpageCard = component ?? "";
    const webpages = component?.webpages ?? [];

    const hasContent = isArrayNotEmpty(webpages);

    return (
        <div style={{ display: "flex", flexDirection: "column" }}>
            <div>
                <h3 className="feature-webpage-title">
                    {title}
                </h3>
            </div>
            <div className={`feature-webpage-container ${webpageCard}_${webpages.length}`}>
                {isArrayNotEmpty(webpages) && webpages.map((webpage, idx) => (
                    <Webpage
                        key={idx}
                        idx={idx}
                        webpage={webpage}
                        webpageCard={webpageCard}
                        total={webpages.length}
                    />
                ))}
                {isArrayEmpty(webpages) &&
                    <EmptyContentMessage hasContent={hasContent} component={component} />
                }
            </div>
        </div>
    );
};

FeatureWebpageComponentDisplay.displayName = "FeatureWebpageComponentDisplay";
export { FeatureWebpageComponentDisplay };
